import apiV2 from '../../api/v2';

export interface ApproveCaseInput {
    option: 'active' | 'starter';
    addOrthopulse: boolean;
}

export async function approveCase(patientId: string, input: ApproveCaseInput): Promise<void> {
    await apiV2.post(`/patients/${patientId}/workflow/approval/approve`, input);
}

export async function requestRevision(patientId: string, note: string): Promise<void> {
    await apiV2.post(`/patients/${patientId}/workflow/approval/request-revision`, { note });
}

export async function declineTreatment(patientId: string, reason: string): Promise<void> {
    await apiV2.post(`/patients/${patientId}/workflow/approval/decline`, { reason });
}
